/* global ssws_verksamheter_images */

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('vardaga-website common.js LOADED');

    /* SEARCH */
    var $search = $('header.banner .search-form');

    $search.submit(function(e) {

      if ($(window).width() >= 992) {
        return true;
      }

      e.preventDefault();
      $search.toggleClass('open');
      let $input = $search.find('.search-field');
      $input.focus();

    });

    $(document).click(function(event) {
        if ( $('.navbar-collapse.show').length === 0 ){
            return;
        }
        let $target = $(event.target);
        if ($target.hasClass('navbar-toggler')){
            return;
        }
        if ($target.parents('.menu-primary-wrapper').length > 0){
            return;
        }
        $('.navbar-toggler').click();
    });

    $(document).ready(function() {
      if (typeof ssws_verksamheter_images !== 'object' || ssws_verksamheter_images.length === 0 ){
        return;
      }
      $(document).on('keydown', function(event) {
        if (event.key !== 'Escape') { return; }
        $('body').removeClass('all-images-modal-body--open');
        $('.vertical-gallery-view').hide();
      });
      $('.absolute-container, .single-visa-alla-bilder').click(function() {
        $('.vertical-gallery-view').show();
        $('body').addClass('all-images-modal-body--open');
        $('.all-images').scrollTop(0);
        let current_slide = $(this).data('key');
        if (!current_slide){
            current_slide = $('.carousel-item.active [data-key]').data('key');
        }
        if ($('.all-images-modal__content--all-images .all-images__image-container').length === 0){
            $('.all-images-modal__content--all-images .all-images__list').html('');
            for (let x=0; x <ssws_verksamheter_images.length; x++ ){
              let link = '';
              if ( typeof ssws_verksamheter_images[x].large === 'object' && typeof ssws_verksamheter_images[x].large.source_url === 'string' ){
                link = ssws_verksamheter_images[x].large.source_url;
              }
              if ( link === '' && typeof ssws_verksamheter_images[x].medium_large === 'object' && typeof ssws_verksamheter_images[x].medium_large.source_url === 'string' ){
                link = ssws_verksamheter_images[x].medium_large.source_url;
              }
              if ( link === '' && typeof ssws_verksamheter_images[x].ssws_verks_gallery === 'object' && typeof ssws_verksamheter_images[x].ssws_verks_gallery.source_url === 'string' ){
                link = ssws_verksamheter_images[x].ssws_verks_gallery.source_url;
              }
              if ( link === '' && typeof ssws_verksamheter_images[x].medium === 'object' && typeof ssws_verksamheter_images[x].medium.source_url === 'string' ){
                link = ssws_verksamheter_images[x].medium.source_url;
              }
              if ( link === '' && typeof ssws_verksamheter_images[x].thumbnail === 'object' && typeof ssws_verksamheter_images[x].thumbnail.source_url === 'string' ){
                link = ssws_verksamheter_images[x].thumbnail.source_url;
              }
              if ( link === '' ){
                  //no valid images found in the set
                  continue;
              }
              let is_active = current_slide === x ? ' active' : '';
              $('.all-images-modal__content--all-images .all-images__list')
                .append(`<div class="all-images__image-container${is_active}" data-key="${x}"><img src="${link}"></div>`);
            }
        } else {
            $('.all-images-modal__content--all-images .all-images__list .active').removeClass('active');
            $(`.all-images-modal__content--all-images .all-images__list [data-key="${current_slide}"]`).addClass('active');
        }
        setTimeout(function(){
            let posTop = $('.all-images__image-container.active').offset().top;
            if ( posTop !== 0 ){
              $('.all-images').animate({scrollTop: posTop}, 100 );
            }
        },200);
      });
      $(document).on('click','.fullscreen-action-bar__close-button',function() {
        $('body').removeClass('all-images-modal-body--open');
        $('.vertical-gallery-view').hide();
      });
      setInterval(function(){
        let item_index = $('.carousel-item.active').index();
        if (typeof item_index === 'number'){
            $('.single-picture-count .current').text(item_index);
        }
      },100);
      $('.carousel').carousel('pause');
      setTimeout(function(){
          if(jQuery('.ais-SearchBox-input').length) {
              jQuery('.ais-SearchBox-input').attr('aria-label',jQuery('.ais-SearchBox-input').attr('placeholder'));
          }
      }, 2000);
    });

    jQuery(window).resize(function($){
      if((parseInt($( window ).width()) + 17) <= 991) {
            $('.footer-mid .widget_nav_menu h4, .footer-bottom .widget_nav_menu h4').each(function(){
                $(this).replaceWith('<a href="javascript:void(0);" title="'+ $(this).text()+'" aria-haspopup="true" aria-expanded="false" style="display:block" class="foo_menu_link">'+ $(this).text()+'</a>');
            });
      }
    });

    jQuery(document).on('click','.footer-inner .widget_nav_menu h4 a', function() {
      jQuery(this).parent().parent('.widget_nav_menu').toggleClass('open');
      if(jQuery(this).attr('aria-expanded')) {
        jQuery(this).attr('aria-expanded', function (i, attr) {
              return attr == 'true' ? 'false' : 'true';
          });
        }
    });
    
    function show_more_onscroll(){
        if ($('.content-bottom.d-none').length){
            $('.content-bottom.d-none').removeClass('d-none');
        } else {
            $(document).off('scroll', show_more_onscroll);
        }
    }
    $(document).on('scroll', show_more_onscroll);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
